(function () {
  var EXPAND = 'memorial-studio:expand';
  var COLLAPSE = 'memorial-studio:collapse';
  var REQUEST_COLLAPSE = 'memorial-studio:request-collapse';

  var backdrop = null;
  var activeIframe = null;
  var originalStyle = null;
  var originalBodyOverflow = null;

  function findIframeForSource(source) {
    var iframes = document.querySelectorAll('iframe#memorial-studio-flipbook, iframe.memorial-studio-flipbook');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow === source) return iframes[i];
    }
    return null;
  }

  function expand(iframe) {
    if (activeIframe) return;
    activeIframe = iframe;
    originalStyle = iframe.getAttribute('style') || '';
    originalBodyOverflow = document.body.style.overflow;

    backdrop = document.createElement('div');
    backdrop.setAttribute('data-memorial-studio-backdrop', '');
    backdrop.style.cssText = [
      'position:fixed', 'inset:0', 'background:rgba(0,0,0,0.55)',
      'z-index:2147483000'
    ].join(';');
    backdrop.addEventListener('click', function () {
      try { iframe.contentWindow.postMessage({ type: REQUEST_COLLAPSE }, '*'); } catch (e) {}
      collapse();
    });
    document.body.appendChild(backdrop);
    document.body.style.overflow = 'hidden';

    iframe.style.cssText = [
      'position:fixed',
      'top:4vh', 'left:50%', 'transform:translateX(-50%)',
      'width:min(96vw, 1200px)', 'height:92vh',
      'z-index:2147483001',
      'border:0', 'border-radius:14px',
      'box-shadow:0 20px 60px rgba(0,0,0,0.5)',
      'background:transparent'
    ].join(';');
  }

  function collapse() {
    if (!activeIframe) return;
    activeIframe.setAttribute('style', originalStyle || '');
    document.body.style.overflow = originalBodyOverflow || '';
    if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
    backdrop = null;
    activeIframe = null;
    originalStyle = null;
  }

  window.addEventListener('message', function (e) {
    var data = e.data;
    if (!data || typeof data.type !== 'string') return;
    if (data.type === EXPAND) {
      var iframe = findIframeForSource(e.source);
      if (iframe) expand(iframe);
    } else if (data.type === COLLAPSE) {
      if (activeIframe && e.source === activeIframe.contentWindow) collapse();
    }
  });

  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeIframe) {
      try { activeIframe.contentWindow.postMessage({ type: REQUEST_COLLAPSE }, '*'); } catch (err) {}
      collapse();
    }
  });
})();
